export const getCategories = (state) => state.categories
export const getCategory = (state) => (category_id) => state.categories.find(x => x.id === category_id) || {}
export const getCategoriesMeta = (state) => state.meta_data


